import React, { useState, useEffect } from "react";

export const Image = ({ title, largeImage, smallImage }) => {
  const [isTouchDevice, setIsTouchDevice] = useState(false);
  
  // Detect if the device supports touch
  useEffect(() => {
    const checkTouch = () => {
      setIsTouchDevice('ontouchstart' in window || navigator.maxTouchPoints > 0);
    };
    
    checkTouch();
    window.addEventListener('resize', checkTouch);
    
    return () => {
      window.removeEventListener('resize', checkTouch);
    };
  }, []);
  
  return (
    <div className="paintings-item">
      <div
        className={`hover-bg ${isTouchDevice ? 'touch-device' : ''}`}
        style={{ backgroundColor: 'rgb(91, 80, 71)' }}
      >
        <a 
          href={largeImage} 
          title={title} 
          data-lightbox-gallery="gallery1"
          aria-label={`View artwork: ${title}`}
        >
          <div className="hover-text">
            <h4>{title}</h4>
          </div>
          <img 
            src={smallImage} 
            className="img-responsive" 
            alt={title} 
            loading="lazy"
          />
        </a>
      </div>
    </div>
  );
};
